import { Card, Form } from 'react-bootstrap';

interface MemberFilterControlsProps {
  memberFilter: 'all' | 'current' | 'active';
  onFilterChange: (filter: 'all' | 'current' | 'active') => void;
}

export function MemberFilterControls({ memberFilter, onFilterChange }: MemberFilterControlsProps) {
  return (
    <Card>
      <Card.Body>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
          <strong className="d-none d-lg-inline">Show Members:</strong>
          <Form.Check
            type="radio"
            id="filter-all"
            name="memberFilter"
            label="All members"
            checked={memberFilter === 'all'}
            onChange={() => onFilterChange('all')}
            inline
          />
          <Form.Check
            type="radio"
            id="filter-active"
            name="memberFilter"
            label={
              <>
                Active members{' '}
                <span className="d-none d-lg-inline">(competing in latest Ryd-Her Cup or in last 2 competitions)</span>
              </>
            }
            checked={memberFilter === 'active'}
            onChange={() => onFilterChange('active')}
            inline
          />
          <Form.Check
            type="radio"
            id="filter-current"
            name="memberFilter"
            label="Current Ryd-Her Cup team only"
            checked={memberFilter === 'current'}
            onChange={() => onFilterChange('current')}
            inline
          />
        </div>
      </Card.Body>
    </Card>
  );
}
